import React, { useState } from 'react'
import './Breadcrumb.scss'
import { isMobile } from '../../helpers/helpers'
import CONSTANTS from '../../Constants'
import { useEffect } from 'react'
import { useLocation, Link } from 'react-router-dom'
import { pushEventToGTM } from '../../helpers/trackerManager'

const Breadcrumb = () => {
  const path = useLocation()
  const [selectedStep, setSelectedStep] = useState(1)
  const [widthPage, setWidthPage] = useState(isMobile())
  const breadcrumbData = [{
    title: CONSTANTS.LABELS.header_quote_ariane1,
    pathName: CONSTANTS.SITE_ROUTS.VEHICLEPAGE,
    stepNumber: 1,
    isEnabled: true,
    eventLabel: 'crumbtrail_vehicule'
  }, {
    title: CONSTANTS.LABELS.header_quote_ariane2,
    pathName: CONSTANTS.SITE_ROUTS.OPERATIONSPAGE,
    stepNumber: 2,
    isEnabled: true,
    eventLabel: 'crumbtrail_operations'
  }, {
    title: CONSTANTS.LABELS.header_quote_ariane3,
    pathName: CONSTANTS.SITE_ROUTS.YOURQUOTEPAGE,
    stepNumber: 3,
    isEnabled: true,
    eventLabel: 'crumbtrail_yourQuote'
  }, {
    title: CONSTANTS.LABELS.header_quote_ariane4,
    pathName: CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE,
    stepNumber: 4,
    isEnabled: selectedStep > 3,
    eventLabel: 'crumbtrail_appointment'
  }, {
    title: CONSTANTS.LABELS.header_quote_ariane5,
    pathName: CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE,
    stepNumber: 5,
    isEnabled: selectedStep > 3,
    eventLabel: 'crumbtrail_infos'
  }, {
    title: CONSTANTS.LABELS.header_quote_ariane6,
    pathName: CONSTANTS.SITE_ROUTS.SUMMARYPAGE,
    stepNumber: 6,
    isEnabled: selectedStep > 3,
    eventLabel: 'crumbtrail_summary'
  }]

  const pathArray = path.pathname.split("/");
  useEffect(() => {
    [...breadcrumbData].map((breadcrumbElement, key) => {
      if (pathArray.includes(breadcrumbElement.pathName.split("/").pop())) {
        setSelectedStep(breadcrumbElement.stepNumber)
      }
    })
  }, [path.pathname])
  useEffect(() => {
    window.addEventListener('resize', () => {
      let browserZoomLevel = window.innerWidth;
      if (browserZoomLevel <= 800) {
        setWidthPage(true);
      }else{
        setWidthPage(false);
      }
    })
  })
  return (
    <nav className='breadcrumb' role='navigation' aria-label='Main navigation'>
      <ul className='breadcrumb-container'>
        {[...breadcrumbData].map((breadcrumbElement, key) => {
          const activatedClass = (pathArray.includes(breadcrumbElement.pathName.split("/").pop())) ? 'activated-box' : ''
          const checkedClass = (breadcrumbElement.stepNumber < selectedStep) ? 'checked-box' : ''
          if (!widthPage) {
            return (
              breadcrumbElement.isEnabled && <Link to={breadcrumbElement.pathName}
                onClick={
                  breadcrumbElement.stepNumber >= selectedStep
                    ?
                    e => e.preventDefault()
                    : () => pushEventToGTM({
                      pageName: 'all',
                      eventAction: `Navigation::${breadcrumbElement.title}`,
                      eventLabel: breadcrumbElement.title,
                      eventCategory: 'Header'
                    })}
                key={key}
                className={`breadcrumb-item ${activatedClass} ${checkedClass}`}>
                <i className='mark-icons nav-icon' ></i>
                <h4 className='breadcrumb-item--title'>{breadcrumbElement.title}</h4></Link>

            )
          }

          else if (pathArray.includes(breadcrumbElement.pathName.split("/").pop())) {
            return (<React.Fragment key={`breadcrumb-${key}`}>
              {key === 0 && <i className={`arrowNavBold-reverse`}></i>}
              {key > 0 && <Link to={breadcrumbData[key - 1].pathName}
                key={key}
                className={`prev-icon  key-${key}`}
              >
                <i className={`arrowNavBold-reverse`}></i>
              </Link>
              }
              <li className='breadcrumb-title'>
                {CONSTANTS.SITE_CONFIG.currentBrand === 'P' && <i className={`mark-icons ${breadcrumbElement.eventLabel}`}></i>}
                <h4 className='step-title'>{breadcrumbElement.title}</h4>
              </li>
              <li className='next-icon'><i className={`arrowNavBold-forward`}></i></li>
            </React.Fragment>
            )
          }
        })
        }
      </ul>
    </nav>
  )

}
export default Breadcrumb;
